import React from 'react';
import { connect } from 'react-redux';
import { createMeetingRoom, resetMeetingRoomForm } from '../../../../actions/meetingRoom';
import { updateShowViewMeetingRoomModal } from '../../../../actions/modal';

@connect()
export default class RightPanelView extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      meetingRoomForm: props.meetingRoomForm,
    };
    this.resetForm = this.resetForm.bind(this);
    this.createMeetingRoom = this.createMeetingRoom.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  UNSAFE_componentWillReceiveProps(props) {
    //THIS EVENT TRIGGERS WHEN THE PARENT UPDATES DATA
    this.setState({ meetingRoomForm: props.meetingRoomForm });
  }

  createMeetingRoom() {
    this.props.dispatch(createMeetingRoom(this.state.meetingRoomForm));
  }

  resetForm() {
    this.props.dispatch(resetMeetingRoomForm());
  }

  closeModal() {
    let show = false;
    this.props.dispatch(updateShowViewMeetingRoomModal(show));
    this.resetForm();
  }

  render() {
    return (
      <div className="ui actions mrbl max-width ">
        <button
          onClick={this.closeModal}
          className="ui cancel  labeled icon button color-bad-things color-bad-things-hover color-white   max-width left-text mrlnull mrbnull"
        >
          <i className="remove  icon" />
          {APP.LANGUAGE.Close}
        </button>
      </div>
    );
  }
}
